export enum EMyAccountTab {
  PROFILE = 'profile',
  ORGANIZATION = 'organization',
}
